var exports = {
  "zp": "LinkedAccountsTab.module__spinnerWrapper___RG9PeW",
  "p$": "LinkedAccountsTab.module__emptyState___RG9PeW",
  "G$": "LinkedAccountsTab.module__platformRow___RG9PeW",
  "h5": "LinkedAccountsTab.module__platformIconButton___RG9PeW",
  "_4": "LinkedAccountsTab.module__domainIcon___RG9PeW",
  "eF": "LinkedAccountsTab.module__connectionsList___RG9PeW",
  "Nr": "LinkedAccountsTab.module__card___RG9PeW",
  "wy": "LinkedAccountsTab.module__cardDragging___RG9PeW",
  "V7": "LinkedAccountsTab.module__cardDragHandle___RG9PeW",
  "EF": "LinkedAccountsTab.module__cardIconSquircle___RG9PeW",
  "Bj": "LinkedAccountsTab.module__cardInfo___RG9PeW",
  "_O": "LinkedAccountsTab.module__cardName___RG9PeW",
  "SI": "LinkedAccountsTab.module__cardNameRow___RG9PeW",
  "vN": "LinkedAccountsTab.module__verificationBadge___RG9PeW",
  "eB": "LinkedAccountsTab.module__cardActions___RG9PeW",
  "hP": "LinkedAccountsTab.module__actionButton___RG9PeW",
  "Il": "LinkedAccountsTab.module__dropIndicatorTop___RG9PeW",
  "Yc": "LinkedAccountsTab.module__dropIndicatorBottom___RG9PeW",
};

module.exports = exports;
